import styled from 'styled-components';

import { theme } from '@/theme/getTheme';

const StyledPlaceholderHeader = styled.div`
  height: ${theme.components.header.wrapper.height.mobile};
  width: 100%;
  background-color: white;
  margin-bottom: 55px;
  ${theme.media.md.up} {
    height: ${theme.components.header.wrapper.height.regular};
    margin-bottom: 65px;
  }
`;

export const PlaceholderHeader = () => {
  return <StyledPlaceholderHeader />;
};
